import React from 'react';
import { Heading, Paragraph } from '@zillow/constellation';

var RatesArticle = function RatesArticle(_ref) {
  var article = _ref.article;
  return /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement(Heading, {
    level: "5",
    as: "h3"
  }, article === null || article === void 0 ? void 0 : article.title), article === null || article === void 0 ? void 0 : article.paragraphs.map(function (p) {
    return /*#__PURE__*/React.createElement(Paragraph, {
      marginTop: "md",
      key: p
    }, p);
  }), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "finePrint",
    marginTop: "sm"
  }, "Last updated: ", article === null || article === void 0 ? void 0 : article.date));
};

export { RatesArticle };
